import { Button, Navbar } from "flowbite-react";
import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Media/qualyvalLogo.webp";

const Header = () => {
  return (
    <Navbar fluid={true} rounded={true} className='font-sansSerif sticky top-0 md:w-11/12 mx-auto py-5 mb-3 mt-8'>
      <Navbar.Brand href="https://flowbite.com/">
        <img
          src={logo}
          className="mr-3 h-6 sm:h-9"
          alt="Flowbite Logo"
        />
      </Navbar.Brand>
      <Navbar.Toggle />
      <Navbar.Collapse >
        <Navbar.Link href="#Projects"><span className="text-secondarySmall text-xl pb-1 md:hover:border-b-4 border-secondaryBG">Projects</span></Navbar.Link>
        <Navbar.Link href="#Benefits"><span className="text-secondarySmall text-xl pb-1 md:hover:border-b-4 border-secondaryBG">Benefits</span></Navbar.Link>
        <Navbar.Link href="#What"><span className="text-secondarySmall text-xl pb-1 md:hover:border-b-4 border-secondaryBG">What we do?</span></Navbar.Link>
        <Navbar.Link href="#How"><span className="text-secondarySmall text-xl pb-1 md:hover:border-b-4 border-secondaryBG">How we do it?</span></Navbar.Link>
        <Navbar.Link href="#Contact"><span className="text-secondarySmall text-xl pb-1 md:hover:border-b-4 border-secondaryBG">Contact</span></Navbar.Link>
        <Navbar.Link href="#Blogs"><span className="text-secondarySmall text-xl pb-1 md:hover:border-b-4 border-secondaryBG">Blogs</span></Navbar.Link>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
